import {
  MANAGE_REPLACE_START,
  MANAGE_RETIRE_START,
  MANAGE_RESET,
  MANAGE_REPROVISION_DEVICE_START,
  MANAGE_ENABLE_FAT_START,
  MANAGE_ENABLE_OAT_START,
  MANAGE_PROVISION_START,
  MANAGE_IDENTIFICATION_START,
  MANAGE_DISCOVERY_START,
  SET_RETIRE_REASON,
} from '../constants/actionTypes';

const initialState = {
  state: 'MENU',
  retiredReason: 1, //default 1
};

const managementReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_RETIRE_REASON:
      return {
        ...state,
        retiredReason: Number(action.retiredReason),
      };
    case MANAGE_REPLACE_START:
      return {
        ...state,
        state: 'REPLACEMENT',
      };
    case MANAGE_RETIRE_START:
      return {
        ...state,
        state: 'RETIRE',
      };
    case MANAGE_REPROVISION_DEVICE_START:
      return {
        ...state,
        state: 'REPROVISION',
      };
    case MANAGE_ENABLE_FAT_START:
      return {
        ...state,
        state: 'ENABLE_FAT',
      };
    case MANAGE_ENABLE_OAT_START:
      return {
        ...state,
        state: 'ENABLE_OAT',
      };
    case MANAGE_PROVISION_START:
      return {
        ...state,
        state: 'PROVISION',
      };
    case MANAGE_IDENTIFICATION_START:
      return {
        ...state,
        state: 'IDENTIFICATION',
      };
    case MANAGE_DISCOVERY_START:
      return {
        ...state,
        state: 'DISCOVERY',
      };
    case MANAGE_RESET:
      return { ...initialState };
    default:
      return state;
  }
};

export default managementReducer;
